import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { getSignInPath } from '@/router';
import { isDefined } from '@/helpers';

@Component({
  name: 'CmgRecentsAndFavoritesPage',
})
export default class CmgRecentsAndFavoritesPage extends Vue {
  loaded = false;

  get showRecents(): boolean | undefined {
    const param = this.$route.query['recents'];
    if (!isDefined(param)) {
      return undefined;
    }

    return param === 'true';
  }

  async mounted() {
    this.init();
  }

  private async init() {
    this.loaded = false;

    if (!(await this.$services.customer.waitForCustomerInitialization())) {
      this.$router.push(getSignInPath(this.$route.path));
      return;
    }

    this.loaded = true;
  }
}
